module.exports = "../images/cabin3-v2.jpg?v=c65e588";